import React from 'react'
import './Eventsection.css'
import Descro_difficile from './assets/Descriptif_parcours_difficile1.png'
import Descro_intermediaire from './assets/Descriptif_parcours_intermediaire1.png'
import Descro_facile from './assets/Descriptif_parcours_facile1.png'
import roadbook_difficile from './assets/roadbook_difficile.pdf'
import roadbook_intermediaire from './assets/roadbook_intermediaire.pdf'
import roadbook_facile from './assets/roadbook_facile.pdf'


function Eventsection () {
  return(
  <div className="event-section">
    <div className="event-section-title">
      <hr></hr>
      <h1>L'évènement</h1>
      <hr></hr>
    </div>
    <div className="envent-section-content">
      <div className="container">
        <div className="container_inner">
          <div className="container_front back_Raid"></div>
          <div className="container_back">
            <h1>Le raid</h1>
            <br/>
            <p>
              <h2>Le Raid des 4 Monts c'est l'événement sportif Compiégnois à ne pas rater !</h2>
            </p>
            <p>
              <h2>Amoureux de la nature, en famille ou entre amis, viens découvrir un des 3 parcours, tu en trouveras forcément un à ton niveau !</h2>
            </p>
            <p>
              <h2>Et même si tu n'as jamais fais de kayak, de course d'orientation, ou de fléché allemands, viens découvrir ces sports dans une ambiance festive.</h2>
            </p>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="container_inner">
          <div className="container_front back_village"></div>
          <div className="container_back">
            <h1>Village associatif</h1>
            <br/>
            <p>
              <h2>Le village est le centre névralgique de l'événement du raid des 4 monts. Il est ouvert à toutes et à tous GRATUITEMENT. </h2>
              </p>
              <p>
              <h2>Vous pourrez y retrouver de nombreuses animations. Seront mis à votre disposition des espaces de restauration, des buvettes et des coins détente. </h2>
              </p>
              <p>
              <h2>Une fois les courses terminées, nous nous y retrouverons tous pour la remise de prix.</h2>
              </p>
              <p>
              <h2>Que vous soyez sportif ou non, s'il y a bien un endroit où il faut se rendre le 7 mai, c'est au village du raid des 4 monts.</h2>
              </p>          
          </div>
        </div>
      </div>
    </div>
    <div className="descriptif">
      <h1>Description</h1>
        <div className="descriptif_parcours">
          <div className="nom_epreuve"><div><b>La Balade de l'Écureuil Roux</b></div><a href={roadbook_facile} className="detail_course" target="_blank">Veuillez cliquer ici pour avoir les détails de la course</a></div>
          <img width="50%" height="50%" src={Descro_facile} alt="bde" />
        </div>
        <div className="descriptif_parcours">
          <div className="nom_epreuve"><div><b>L'Exploration du Chevreuil<br/>Capreolus</b></div><a href={roadbook_intermediaire} className="detail_course" target="_blank">Veuillez cliquer ici pour avoir les détails de la course</a></div>
          <img width="50%" height="50%" src={Descro_intermediaire} alt="bde" />
        </div>
        <div className="descriptif_parcours">
          <div className="nom_epreuve"><div><b>L’Expédition du Loup Gris</b></div><a href={roadbook_difficile} className="detail_course" target="_blank">Veuillez cliquer ici pour avoir les détails de la course</a></div>
          <img width="50%" height="50%" src={Descro_difficile} alt="bde" />
        </div>
    </div>
  </div>
)
}

export default Eventsection
